const data = [
  {
    img: '/assets/img/profiles/l-11.jpg',
    title: 'ثبت‌نام دانش‌آموز جدید',
    subtitle: 'مجید اکبری - خمین',
    seen: false,
    id: 1
  },
  {
    img: '/assets/img/notifications/thumb-1.png',
    title: 'اطلاعیه جدید',
    subtitle: 'مهلت ثبت اطلاعات سال 1399',
    seen: false,
    id: 2
  },
  {
    img: '/assets/img/notifications/thumb-2.jpg',
    title: 'رویداد جدید',
    subtitle: 'کوهنوردی سبلان',
    seen: false,
    id: 3
  },
  {
    img: '/assets/img/notifications/thumb-3.jpg',
    title: 'پیام جدید',
    subtitle: 'مسئول استان',
    seen: false,
    id: 4
  }
]
export default data
